import { __ } from "src/libs/utilities"
import { ILandingContent, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { components } from "src/modules/pe-landing-module/data/utils/components"

/* Protopia Ecosystem component */
export interface IDummyProps<T extends ILandingContent> {
   data: T
}
function  Dummy<T extends ILandingContent> ( { data, ...props }: IDummyProps<T> ): JSX.Element {
    return <div
            className={` landing-empty ${data.className }`}
            style={data.style}
        >
            <img
                src={ components()[ data.type || LANDING_TYPE_CONTENT.CANVAS ]?.icon }
                className="svg-force-contrast opacity_5 landing-icon mb-2"
                alt={__( components()[ data.type || LANDING_TYPE_CONTENT.CANVAS ]?.title || "Empty canvas" )}
            />
            <div className="letter-spacing-2 small text-force-contrast opacity_5">
                { __( components()[ data.type || LANDING_TYPE_CONTENT.CANVAS ]?.title || "Empty canvas" ) }
            </div>
            <div className="small letter-spacing-2 opacity_75">
                {
                    __( data.commentary )
                }
            </div>
    </div>
}
export default Dummy